export default {
  name: 'PhoneToken',
  props: {
    digits: {
      type: Number,
      required: false,
      default: 6
    }
  },
  data () {
    return {
      inputs: {}
    }
  },
  computed: {
    value: function () {
      const values = Object.keys(this.inputs).length

      if (values === 0 || values < 6) {
        return null
      }

      const value = parseInt(Object.values(this.inputs).join(''), 10)

      return isNaN(value) ? null : value
    }
  },
  methods: {
    async emitValue (event) {
      await this.$nextTick()
      this.$emit('input', this.value)
    },
    stripExtraNumbers (event) {
      const dataElement = event.target.getAttribute('name').replace(/\D/g, '')
      const value = event.target.value

      if (value.length > 1) {
        this.$set(this.inputs, dataElement, value.slice(1, 2))
        return
      }

      if (event.key === 'Backspace' && dataElement <= 1) {
        return
      }

      if (event.key === 'Backspace' && dataElement > 1) {
        this.inputs[dataElement - 1] = ''
        event.target.previousSibling.focus()
        this.$emit('input', this.value)
        return
      }

      if (event.key !== 'Backspace' && dataElement < this.digits && event.key !== 'Tab') {
        event.target.nextElementSibling.focus()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/component/inputs/phoneToken/phoneToken.js